import React from 'react';

import classes from './TitleBlock.module.scss';
import { ReactComponent as AddNewPersonIcon } from '../../../../../../shared/assets/icons/add-new-person.svg';

const TitleBlock = () => {
  return (
    <div className={classes.titleBlock}>
      <div className={classes.iconRow}>
        <AddNewPersonIcon className={classes.addNewPersonIcon} />
      </div>
      <h3>Almost done!</h3>
      <p>It remains to create Password for quick login</p>
    </div>
  );
};

export { TitleBlock };
